import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "../permissoes/Permissoes.module.css";
import GrupoDeUsuarioApi from "../../services/GrupoDeUsuarioApi";
import { useEffect, useState } from "react";
import Alerta from "../../components/alerta/Alerta";
import Form from 'react-bootstrap/Form';
import FuncionalidadeApi from "../../services/FuncionalidadeApi";
import { useLocation, useNavigate } from "react-router-dom";
import GrupoDeUsuarioFuncionalidade from "../../services/GrupoDeUsuarioFuncionalidade";
import BotaoSalvar from "../../components/botaoSalvar/BotaoSalvar";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";




function Permissoes() {

  const location = useLocation();
  const { id, nome } = location.state;


  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  const [grupoDeUsuario, setGrupoDeUsuarios] = useState([]);
  const [grupoSelecionado, setgrupoSelecionado] = useState(null);


  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const [FuncionalidadesSelecionadas, setFuncionalidadesSelecionadas] = useState([]); // só os  id das funcionalidades

  const [funcionalidadesEnum, setFuncionalidadesEnum] = useState([]);

  const [todasFuncionalidades, setTodasFuncionalidades] = useState([]);
  const [ListaFuncionalidadeSistema, setListaFuncionalidadePorSistema] = useState({})


  const [loading, setLoading] = useState(false);


  const gerenciarSelecaoFuncionalidades = (e) => {
    const { id, checked } = e.target;
    setFuncionalidadesSelecionadas((prev) =>
      checked ? [...prev, Number(id)] : prev.filter((item) => item !== Number(id))
      // se checked for true adiciono o id se nao removo id do array 
    );

  };

  const exibirAlerta = (mensagem, tipo) => {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipo);
    setMostrarAlerta(true);

    // Após exibir o alerta, redirecionar depois de 3 segundos
    setTimeout(() => {
      setMostrarAlerta(false);
      if (tipo === "success") {
        navigate("/backoffice/grupoDeUsuario");
      }
    }, 1000);
  };

  const editarGrupoUsuario = async () => {
    try {
      await GrupoDeUsuarioApi.AtualizarGrupoDeUsuarioAsync(
        grupoSelecionado.value,
        grupoSelecionado.label,
        grupoSelecionado.descricao

      );
      carregarGrupoDeUsuarios();
    } catch (error) {

    }
  }

  const AtualizarGrupoDeUsuario = async () => {
    if (!id) {
      exibirAlerta("Grupo de usuário não identificado.", "danger");
      return;
    }

    try {
      await GrupoDeUsuarioFuncionalidade.AtualizarGrupoDeUsuarioFuncionalidadeAPI(
        id,
        FuncionalidadesSelecionadas
      );
      await editarGrupoUsuario();
      exibirAlerta("Permissões Atualizadas com sucesso!", "success");

    } catch (error) {
      const mensagemErro =
        error.response?.data?.message ||
        error.response?.data?.title ||
        (typeof error.response?.data === "string" ? error.response.data : null) ||
        error.message ||
        "Erro desconhecido";

      exibirAlerta(`Erro ao atualizar: ${mensagemErro}`, "danger");
    }
  }

  const FuncionalidadesListar = async () => {
    try {
      const ListaFuncionalidade = await FuncionalidadeApi.ListarFuncionalidadeAsync(true);

      setTodasFuncionalidades(ListaFuncionalidade)
    } catch (error) {
      console.error("Erro ao carregar grupos de usuários:", error);
    }
  };




  const FuncionalidadeListadaPorSistema = async () => {
    try {
      setLoading(true);
      const listaFuncionalidade = await FuncionalidadeApi.ListarFuncionalidadeAsync(true);

      // Agrupar por sistema em minúsculo para evitar duplicidade por case
      const agrupado = listaFuncionalidade.reduce((acc, func) => {
        const nomeSistema = (func.sistema || "sem nome").toLowerCase();
        if (!acc[nomeSistema]) acc[nomeSistema] = [];
        acc[nomeSistema].push(func);
        return acc;
      }, {});

      setListaFuncionalidadePorSistema(agrupado);
    } catch (error) {
      console.error("Erro ao carregar funcionalidades:", error);
    } finally {
      setLoading(false);
    }
  };


  const ListarFuncionalidadesEnum = async () => {
    try {
      const listaEnum = await FuncionalidadeApi.ListarFuncionalidadesEnum();
      setFuncionalidadesEnum(listaEnum);
    } catch (error) {
      console.error("Erro ao carregar enum de funcionalidades:", error);
    }
  }

  const CarregarFuncionalidadesDoGrupo = async (grupoDeUsuarioId) => {
    try {
      const vinculos = await GrupoDeUsuarioFuncionalidade.ObterGrupoDeUsuarioFuncionalidadeAsync(grupoDeUsuarioId);
      const idsMarcados = vinculos.map(v => v.funcionalidadeId);
      setFuncionalidadesSelecionadas(idsMarcados);
    } catch (error) {
      console.error("Erro ao carregar funcionalidades do grupo:", error);
    }
  };




  const carregarGrupoDeUsuarios = async () => {
    try {
      const listaGrupoDeUsuarios = await GrupoDeUsuarioApi.ListarGrupoDeUsuarioAsync(true);


      const grupoOptions = listaGrupoDeUsuarios.map(grupo => ({
        value: grupo.id,
        label: grupo.nome,
        descricao: grupo.descricao,
        funcionalidades: grupo.funcionalidades || []

      }));


      setGrupoDeUsuarios(grupoOptions);

    } catch (error) {
      console.error("Erro ao carregar grupos de usuários:", error);
    }
  };


  useEffect(() => {
    FuncionalidadeListadaPorSistema();
    FuncionalidadesListar();
    carregarGrupoDeUsuarios();
    ListarFuncionalidadesEnum();
  }, []);

  useEffect(() => {
    if (id) {
      const grupoSelecionado = grupoDeUsuario.find(grupo => grupo.value === id);
      setgrupoSelecionado(grupoSelecionado);

      CarregarFuncionalidadesDoGrupo(id);
    }
  }, [id, grupoDeUsuario]);

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto}
      setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar

        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}

      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          {/* Cabeçalho da página */}

          <div className={style.container_cabecalho}>
            <h4 className={style.cabecalho}>Editar grupo de usuário</h4>
          </div>


          <div className={style.corpo_principal}>
            <div className={style.corpo}>
              <h1 className={style.descricao}>Nome</h1>
              <InputBuscar
                maxLength={100}
                type="text"
                value={grupoSelecionado?.label || ""}
                onChange={(e) => {

                  const grupoAtualizado = { ...grupoSelecionado, label: e.target.value };
                  setgrupoSelecionado(grupoAtualizado);

                  // Manter funcionalidades marcadas associadas ao grupo
                  const funcionalidadesMarcadas = grupoAtualizado?.funcionalidades.map(f => f.id) || [];
                  setFuncionalidadesSelecionadas(funcionalidadesMarcadas);
                }}

              />
            </div>
            <div className={style.corpo}>
              <h1 className={style.descricao}>Descrição</h1>
              <InputBuscar
                maxLength={150}
                type="text"
                value={grupoSelecionado?.descricao || ""}
                onChange={(e) => {

                  const grupoAtualizado = { ...grupoSelecionado, descricao: e.target.value };
                  setgrupoSelecionado(grupoAtualizado);

                  // Manter funcionalidades marcadas associadas ao grupo
                  const funcionalidadesMarcadas = grupoAtualizado?.funcionalidades.map(f => f.id) || [];
                  setFuncionalidadesSelecionadas(funcionalidadesMarcadas);
                }}

              />
            </div>
          </div>
          <hr>
          </hr>
          <div className={style.container_cabecalho}>
            <h4> Selecionar Funcionalidades</h4>
          </div>
          <div className={style.chek_box}>

            <Form>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                {Object.entries(ListaFuncionalidadeSistema).map(([nomeGrupo, funcionalidades], index) => {
                  // Capitaliza só a primeira letra
                  const nomeFormatado = nomeGrupo.charAt(0).toUpperCase() + nomeGrupo.slice(1);

                  return (
                    <div
                      key={nomeGrupo}
                      className={style.checkboxGroup}
                      style={{ flex: '0 0 48%' }}
                    >
                      <h5>{nomeFormatado}</h5>
                      {funcionalidades.map(func => {
                        const funcionalidadeEnum = funcionalidadesEnum.find(f => f.id === func.id);
                        const descricao = funcionalidadeEnum?.descricao || func.nome;

                        return (
                          <Form.Check
                            key={func.id}
                            className={style.Check_box_interno}
                            type="checkbox"
                            id={func.id}
                            label={descricao}
                            onChange={gerenciarSelecaoFuncionalidades}
                            checked={FuncionalidadesSelecionadas.includes(func.id)}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </Form>

          </div>
          <div className={style.Botao_Salvar}>
            <BotaoSalvar
              onClick={AtualizarGrupoDeUsuario}
            />
          </div>
        </div>
      </Topbar>
    </Sidebar >
  );
}

export default Permissoes;
